import { Box } from '@chakra-ui/react';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/home';
import ProjectsPage from './pages/projects/projects';
import { ROUTES } from './routes/routes';
import Footer from './pages/footer';

const appRoutes = [
  { path: ROUTES.HOME, element: <Home /> },
  { path: ROUTES.PROJECTS, element: <ProjectsPage /> },
];

const App = () => {
  return (
    <Box>
      {/* <Header /> */}
      <Routes>
        {appRoutes.map((route, index) => (
          <Route key={index} path={route.path} element={route.element} />
        ))}
      </Routes>
      <Footer />
    </Box>
  );
};

export default App;
